const defaultSuffix = '([!%]?[\\w]*)'; // like !default / !edit / %21viewLogs
export const legacyGinIssueCloneRoute = {
	name: 'legacy-gin-issue-clone',
	path: `/(secure|issue)/CloneIssue(\\w*)${defaultSuffix}.jspa`,
};
